import config from "@/config"
import http from "@/utils/request"

export default {
	question:{
       index:{
            url: `${config.API_URL}/bwmall/admin/question/index`,
            name: "获取常见问题",
            get: async function(params){
                return await http.get(this.url, params);
            }
        },
        edit:{
            url: `${config.API_URL}/bwmall/admin/question/edit`,
            name: "编辑",
            post: async function(params){
                return await http.post(this.url, params);
            }
        },
        add:{
            url: `${config.API_URL}/bwmall/admin/question/add`,
            name: "添加",
            post: async function(params){
                return await http.post(this.url, params);
            }
        },
        del:{
            url: `${config.API_URL}/bwmall/admin/question/del`,
            name: "删除",
            post: async function(params){
                return await http.post(this.url, params);
            }
        },
        modify:{
            url: `${config.API_URL}/bwmall/admin/question/modify`,
            name: "变更",
            post: async function(params){
                return await http.post(this.url, params);
            }
        }
    },
	bwmallDashboard:{
		url: `${config.API_URL}/bwmall/admin/bwmallDashboard`,
		name: "控制台数据",
		get: async function(data={}){
			return await http.get(this.url, data);
		}
	},
	// 签到管理（内置化旧插件 addons/signin 后台）
	signin:{
		config:{
			url: `${config.API_URL}/bwmall/admin/signin/config`,
			name: "签到配置读取",
			get: async function(params){
				return await http.get(this.url, params);
			},
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		recordList:{
			url: `${config.API_URL}/bwmall/admin/signin/recordList`,
			name: "签到记录列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		recordDel:{
			url: `${config.API_URL}/bwmall/admin/signin/recordDel`,
			name: "删除签到记录",
			post: async function(params){
				return await http.post(this.url, params);
			}
		}
	}

}
